import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

/**
 * Извлекает параметры шрифта из шрифтовой константы для properties.customize.font
 */
const formatFonts = (): Record<string, string> => {
    const formattedFonts = {};
    for (const key in FONTS) {
        formattedFonts[key] = FONTS[key].replace('font: ', '').replace(/;$/g, '');
    }
    return formattedFonts;
};

export const fonts = formatFonts();
